import { render, staticRenderFns } from "./AuctionHistoryModal.vue?vue&type=template&id=21b0556a&scoped=true"
import script from "./AuctionHistoryModal.vue?vue&type=script&lang=js"
export * from "./AuctionHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b0556a",
  null
  
)

export default component.exports